import CoreDialogsModule from './module';
import CoreDialogsService from './service';
import CoreDialogInstance from './factories/dialog';
import { CoreDialogConsumer, CoreDialogProvider } from './Wrapper';

export { CoreDialogsModule, CoreDialogInstance, CoreDialogsService, CoreDialogConsumer, CoreDialogProvider };
